export const GET_IMAGES_TIMEOUT_MS = 10000
